var basepath = './';
export const xiaodianinstruction = {
  xiaodianTitle: '<p style=\'font-size:18px;color:#333333;margin-top:20px;\'>美菱小家电</p>',
  xiaodianContent:
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian01">一、厨卫、净水及小家电产品保修政策：</p>\n' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>2019年3月15日起购买的，且生产日期为2018年1月1日之后的均可享受以下包修政策；生产日期为2018年1月1日之前的所有产品按原保修政策执行。</div>' +
    '<img src="' + basepath + 'static/zc01.png" style=\'width:100%;\' \/>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>备注：用于商用（酒店、餐饮、发廊等非家用场合）的整机包修半年；除政府工程总部统一明确保修期外，其他工程按工程合同保修时间为准，无法提供合同的按1年保修。</div>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian02">二、美菱生产日期为2018年1月1日之前或购买日期为2019年3月15日之前所有产品保修政策：整机免费保修一年，主要部件三年。</p>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>主要零部件明细：</div>' +
    '<img src="' + basepath + 'static/zc02.png" style=\'width:100%;\' \/>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian03">三、注意事项：</p>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>（1）保修期界定：以有效保修凭证的开具日期作为保修期的起始日期；没有有效保修凭证，按产品生产日期顺延90天计算。若既无有效保修凭证也无出厂日期及条码，则按保外处理。</div>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>（2）保修凭证：包含发票、有效收据（盖有销售单位公章）、电商购买订单信息等。</div>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian04">四、免责条款: </p>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>下列情况不属“三包”范围，可实行收费修理：' +
    '（1）消费者因搬运、使用、维护、保管不当造成损坏的；\n' + '<br>\n' +
    '（2）非我公司指定的维修点安装、维修造成损坏的（包括消费者自行安装或拆卸修理的）；\n' + '<br>\n' +
    '（3）无保修卡及有效发票或购买证明，且无法证明属于保修期内的；\n' + '<br>\n' +
    '（4）发票或保修卡与实物不符或涂改的；\n' + '<br>\n' +
    '（5）因不可抗拒的自然灾害造成损坏的（雷电、地震等）；\n' + '<br>\n' +
    '（6）超过保修期的；\n' + '<br>\n' +
    '（7）使用环境（如电压、湿度、温度、通风条件等）不合产品说明书的表述，造成损坏的。\n' +
    '</div>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian05">五、安装辅材收费标准：</p>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>1、电热水器常规环境安装辅材最高限价 200 元，燃气热水器常规环境安装辅材最高限价 300 元。</div>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>2、常规环境安装辅材限价包含以下内容：' +
    '(1)常规环境下电热水器有效管路安装范围为3米（进出水管合计为3米），不含混水阀；\n' + '<br>\n' +
    '(2)常规环境下燃气热水器有效管路安装范围为3米（进出水管合计为3米）、烟道管加长不超过2米，不含气阀、燃气管。\n' + '<br>\n' +
    '(3)限价服务范围仅3米内辅材，不含打穿墙孔、玻璃开孔、打支架、拆吊顶、拆旧机等类似与产品安装无直接关联的工作。\n' + '<br>\n' +
    '(4)用户自备辅材按照30元/台收取辅材安装费并承担相应的辅材安全责任，由服务网点销售并安装的辅材由服务网点质保半年。\n' + '<br>\n' +
    '(5)安新机拆旧机20-40元，单独拆旧机50-80元。\n' + '<br>\n' +
    '(6)非常规安装服务项目收费标准\n' + '<br>\n' +
    '</div>' +
    '<img src="' + basepath + 'static/zc03.png" style=\'width:100%;\' \/>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>(7)辅材收费标准</div>' +
    '<img src="' + basepath + 'static/zc04.png" style=\'width:100%;\' \/>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>备注：北上广深在以上基础上浮30%；服务项目在本表未体现的，按当地市场价格执行。</div>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian06">六 、厨卫家电类保外维修收费指导标准：</p>' +
    '<img src="' + basepath + 'static/zc05.png" style=\'width:100%;\' \/>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>1.上门服务：首次上门单程15公里以内免收路程费；超出15公里以外每公里加收1.5元；茶吧机搬动维修超出15公里以外每公里加收3元。</div>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>2.如因用户原因导致的多次上门，按照单程15公里以内收取上门服务费30元，超出部分每公里加收1.5元计算。</div>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian07">七、拆机、移机统一收费指导标准(元)：</p>' +
    '<img src="' + basepath + 'static/zc06.png" style=\'width:100%;\' \/>' +
    '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="xiaodian08">八、小电类保外维修指导收费标准：</p>' +
    '<img src="' + basepath + 'static/zc07.png" style=\'width:100%;\' \/>' +
    '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>备注：厨房小电与生活家电类产品需用户送修/检，不提供上门服务。如果需要上门服务，由用户支付50元/台的上门服务费。</div>'
}


// WEBPACK FOOTER //
// ./src/struction/meilingXiaodian.js